//@flow
import * as React from 'react'
import type { ContainerRowTitle$Props } from './flowTypes'

const ContainerRowTitle=(props:ContainerRowTitle$Props)=>{
    return (
        <div className='row'>
            <div className="col-sm">
                <h3>{props.title}</h3>
            </div>
        </div>
    )
}

export default ContainerRowTitle


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowTitle.js